export default {
  salesforcePostLeadURL: __DEV__
    ? 'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8'
    : 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
  salesforceOID: __DEV__ ? '00D6E0000009CcS' : '00D0Y000000YKnV',
};
